var irreducible = require('./irreducible');
var isNil = require('./isNil');

module.exports = irreducible('Nil', isNil);



//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/Nil.js
// module id = 940
// module chunks = 1